import { mergeProps } from '@zag-js/solid';
import { ark } from '../factory';
import { useDatePickerContext } from './use-date-picker-context';
import { useDatePickerTableContext } from './use-date-picker-table-props-context';
export const DatePickerTableHead = (props) => {
    const api = useDatePickerContext();
    const tableProps = useDatePickerTableContext();
    const mergedProps = mergeProps(() => api().getTableHeadProps(tableProps), props);
    return <ark.thead {...mergedProps}/>;
};
